import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

// This is a wrapper around clsx that also merges tailwind classes
// It is used in the radix ui components being pulled in from shadcn
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Get formatters for a given locale to be used on numbers,
 * this is used in the comma separated number input
 *
 * @param locale - the locale to use
 * @returns an object containing the format and unformat functions
 */
export const getFormatters = (locale: string) => {
  const numberWithGroupAndDecimalSeparator = Intl.NumberFormat(locale, {
    style: 'decimal',
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 20,
  })

  const example = numberWithGroupAndDecimalSeparator.format(1234567.89)
  const decimal = example.charAt(example.length - 3)
  const group = example.charAt(example.length - 7)

  return {
    format: (num: string) => {
      const [intPart, fracPart] = num.split('.')
      const formatted = numberWithGroupAndDecimalSeparator.format(Number(intPart))
      return fracPart ? `${formatted}${decimal}${fracPart}` : formatted
    },
    unformat: (num: string) =>
      num.replace(new RegExp(`[^\\d${decimal}]`, 'g'), '').replace(decimal, '.'),
    decimal,
    group,
  }
}
